<!-- eslint-disable vue/no-unused-components -->
<template>
  <b-modal
    size="lg"
    v-model="modalItem"
    :title="
      editable
        ? 'Editar custo'
        : modalItemForm
        ? 'Cadastrar outro custo'
        : 'Excluir imposto'
    "
    class="text-center text-primary d-flex align-items-center"
    no-close-on-backdrop
    hide-footer
    hide-header-close
  >
    <b-form v-if="modalItemForm">
      <b-row
        class="my-1 m-2 text-left mt-4 d-flex justify-content-center flex-column"
      >
        <!-- GROUP -->
        <b-form-group v-slot="{ ariaDescribedby }" class="mb-2">
          <label class="font-weight-bold text-primary">Tipo de Custo:</label>
          <b-form-radio-group disabled v-model="modelItem.group">
            <b-form-radio
              name="selected-prefix-tax"
              :aria-describedby="ariaDescribedby"
              value="other_cost"
              >Outro custo</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>

        <!-- PROJETOS -->
        <!-- <b-form-group v-if="modelItem.group !== 'offices'" class="mb-2">
            <label for="category" class="font-weight-bold text-primary"
              >Projetos :</label
            >
            <b-form-select id="category" v-model="modelItem.project_id">
              <option
                v-for="project in projects"
                :key="project.id"
                :value="project.id"
              >
                {{ project.project_code }} - {{ project.project_name }}
              </option>
            </b-form-select>
          </b-form-group> -->

        <!-- FORNECEDORES -->
        <b-form-group class="mb-2">
          <b-col cols="12">
            <label for="category" class="font-weight-bold text-primary"
              >Fornecedor :</label
            >

            <v-select
              ref="vselect_supplier"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione uma categoria"
              v-model="modelItem.supplier_id"
              :options="supplier"
              label="supplier_name"
              :searchable="true"
              :reduce="(supplier) => supplier.id"
            />
            <p v-if="$v.modelItem.supplier_id.$error" style="color: red">
              *Um fornecedor é necessário.
            </p>
          </b-col>
        </b-form-group>

        <!-- CATEGORIAS -->
        <b-form-group class="mb-2">
          <b-col cols="12">
            <b-form-group class="mb-2">
              <label for="category" class="font-weight-bold text-primary"
                >Categoria do custo
              </label>

              <v-select
                ref="vselect"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Selecione uma categoria"
                v-model="modelItem.expense_category_id"
                :options="categories"
                label="expense_category_name"
                :searchable="true"
                :reduce="(category) => category.id"
              />
              <p
                v-if="$v.modelItem.expense_category_id.$error"
                style="color: red"
              >
                *Uma categoria é necessária.
              </p>
            </b-form-group>
          </b-col>
        </b-form-group>

        <!-- VALOR -->
        <b-form-group class="mb-2" :disabled="modelItem.isRepeatActive">
          <label for="value" class="font-weight-bold text-primary"
            >Valor Monetário:</label
          >
          <b-input-group>
            <b-form-input
              id="value"
              type="text"
              v-model="modelItem.value"
              v-money="moneyMask"
            ></b-form-input>
          </b-input-group>
          <p v-if="$v.modelItem.value.$error" style="color: red">
            *Um fornecedor é necessário.
          </p>
        </b-form-group>

        <!-- DATA DE REFERÊNCIA -->
        <b-form-group class="mb-2" :disabled="modelItem.isRepeatActive">
          <label for="referenceDate" class="font-weight-bold text-primary"
            >Data de Referência:</label
          >
          <b-form-input
            id="referenceDate"
            type="date"
            v-model="modelItem.reference_date"
          ></b-form-input>
        </b-form-group>
        <p v-if="$v.modelItem.reference_date.$error" style="color: red">
          *Um fornecedor é necessário.
        </p>

        <!-- DATA DE Transação -->
        <b-form-group class="mb-2">
          <label for="transactionDate" class="font-weight-bold text-primary"
            >Data da Transação:</label
          >
          <b-form-input
            id="transactionDate"
            type="date"
            v-model="modelItem.transaction_date"
          ></b-form-input>
          <p v-if="$v.modelItem.transaction_date.$error" style="color: red">
            *Um fornecedor é necessário.
          </p>
        </b-form-group>

        <!-- STATUS -->
        <b-form-group v-slot="{ ariaDescribedby }" class="mb-2">
          <label class="font-weight-bold text-primary">Status:</label>
          <b-form-radio-group v-model="modelItem.status">
            <b-form-radio
              name="selected-prefix-will"
              :aria-describedby="ariaDescribedby"
              value="previsto"
              >Previsto</b-form-radio
            >
            <b-form-radio
              name="selected-prefix-was"
              :aria-describedby="ariaDescribedby"
              value="realizado"
              >Realizado</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>

        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label class="font-weight-bold text-primary"
                >Condição de Pagamento:</label
              >
              <b-form-select
                v-model="modelItem.type"
                :options="typesOptions"
                placeholder="Selecione o status"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- DESCRICAO -->
        <b-form-group class="mb-2">
          <label class="font-weight-bold text-primary">Descrição:</label>
          <b-form-textarea v-model="modelItem.description"></b-form-textarea>
        </b-form-group>
      </b-row>

      <!-- Se Parcelado -->
      <div
        v-if="
          modelItem.type == 'Parcelado' ||
          (modelItem.type == 'Recorrência' && modelItem.value)
        "
      >
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <b-input-group
                :prepend="
                  modelItem.type == 'Parcelado' ? 'Parcelas' : 'Recorrências'
                "
              >
                <BFormInput
                  id="installmentsInput"
                  type="number"
                  v-model="installmentsInput"
                ></BFormInput>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Parcelas -->
        <div v-if="modelItem.value && installmentsInput > 0">
          <div v-for="i in parseInt(installmentsInput)" :key="i">
            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <b-input-group prepend="R$">
                    <BFormInput
                      :id="`installment-value`"
                      type="text"
                      :ref="`installments-value-${i}`"
                      :value="
                        numberToMonetary(
                          monetaryToNumber(modelItem.value) /
                            parseInt(installmentsInput),
                        )
                      "
                      v-money="moneyMask"
                    ></BFormInput>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group prepend="">
                  <BFormInput
                    :id="`installment-date`"
                    :ref="`installments-date-${i}`"
                    type="date"
                    :value="installmentIncrease(i)"
                  ></BFormInput>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

      <hr class="invoice-spacing mb-3" />

      <b-row class="justify-content-between d-flex p-2">
        <!-- back -->
        <b-button
          :disabled="loading"
          variant="warning"
          class="mr-2"
          @click="closeModal()"
          >Voltar
        </b-button>

        <b-button
          v-if="editable && !modelItem.is_blocked"
          variant="danger"
          @click="() => (modalInactivate = true)"
          :disabled="modelItem.status.length < 1 || loading"
        >
          <span v-if="!loading"> Excluir custo </span>
          <b-spinner class="spinner" v-if="loading"></b-spinner>
        </b-button>

        <div class="d-flex justify-content-between">
          <b-button
            v-if="editable && !modelItem.is_blocked"
            variant="primary"
            @click="updateProjectCosts"
            :disabled="modelItem.status.length < 1 || loading"
          >
            <span v-if="!loading"> Salvar Alterações </span>
            <b-spinner class="spinner" v-if="loading"></b-spinner>
          </b-button>

          <!-- saveUser -->

          <b-button
            v-if="!editable"
            variant="primary"
            @click="saveProjectCosts"
            :disabled="loading"
          >
            <span v-if="!loading">Salvar</span>
            <b-spinner v-if="loading"></b-spinner>
          </b-button>
        </div>
        <!-- modalInativate -->
        <b-modal
          title="Excluir custo"
          no-close-on-backdrop
          hide-footer
          hide-header-close
          v-model="modalInactivate"
        >
          <b-row class="mt-1 justify-content-center d-flex text-center">
            <p>
              Deseja realmente
              <strong>{{
                modelItem.is_blocked ? 'excluir' : 'inativar'
              }}</strong>
              este custo ?
            </p>
          </b-row>
          <hr class="invoice-spacing mb-3" />
          <b-row class="justify-content-between d-flex mt-3 p-1">
            <b-button variant="warning" @click="modalInactivate = false">
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              @click="
                modelItem.is_blocked ? activeCosts() : removeProjectCosts()
              "
            >
              Confirmar
            </b-button>
          </b-row>
        </b-modal>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import moment from 'moment';

export default {
  name: 'new-projectCosts',
  props: {
    editable: {
      Type: Boolean,
      default: false,
    },
    modalItem: {
      Type: Boolean,
      default: false,
    },
    modalItemForm: {
      Type: Boolean,
      default: false,
    },
    modalOpenToDeleted: {
      Type: Boolean,
      default: false,
    },
    itemUpdate: {
      type: Object && String && Number,
      default: null,
    },
  },

  data() {
    return {
      modelItem: {
        value: 0,
        reference_date: moment().format('YYYY-MM-DD'),
        transaction_date: moment().format('YYYY-MM-DD'),
        status: 'realizado',
        description: '',
        type: 'À vista (uma vez)',
        repeat: 0,
        group: 'projects',
        supplier_id: '',
        expense_category_id: '',
        project_id: '',
        is_blocked: false,
        created_by: '',
      },
      modelItemDefault: {
        value: 0,
        reference_date: moment().format('YYYY-MM-DD'),
        transaction_date: moment().format('YYYY-MM-DD'),
        status: 'realizado',
        description: '',
        repeat: 0,
        group: 'projects',
        type: 'À vista (uma vez)',
        supplier_id: '',
        expense_category_id: '',
        project_id: '',
        is_blocked: false,
        created_by: '',
      },
      projects: [],
      supplier: [],
      categories: [],
      installments: [],
      installmentsInput: 2,
      typesOptions: ['À vista (uma vez)', 'Parcelado', 'Recorrência'],
      instalment_date_increase: moment().format('YYYY-MM-DD'),

      modalInactivate: false,
      loading: false,
      required,
      moneyMask: {
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        masked: false,
      },
    };
  },
  validations() {
    return {
      modelItem: {
        expense_category_id: {
          required,
        },
        supplier_id: {
          required,
        },
        value: {
          required,
          notZero: (value) => value !== '0,00' || value !== 0,
        },

        reference_date: {
          required,
        },
        transaction_date: {
          required,
        },
      },
    };
  },
  setup() {
    return { $v: useVuelidate() };
  },
  watch: {
    modalItemForm(newVal) {
      if (newVal) {
        this.loadProjects();
      }
    },
    modalItem(newVal) {
      if (newVal) {
        this.loadProjects();
      }
    },

    editable(itemUpdate) {
      if (itemUpdate) {
        this.getProjectCosts();
      }
    },
  },

  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
    currentUser() {
      return this.$store.getters.user.accesses.find(
        (a) => a.workspace_id == this.$store.getters.currentWorkspace.id,
      );
    },
  },
  created() {
    // this.loadProjects();
    this.getMemberId();
  },
  beforeMount() {
    if (this.modalItemForm) {
      this.loadProjects();
    }

    if (this.editable) {
      this.getProjectCosts();
    }
  },

  methods: {
    setType() {
      this.typesOptions = [];
      if (this.is_project_expense == true) {
        this.typesOptions.push('À vista (uma vez)', 'Parcelado');
      }
    },
    installmentIncrease(i) {
      let installmentDate = moment(this.modelItem.transaction_date);
      installmentDate.add(i - 1, 'months');

      return installmentDate.format('YYYY-MM-DD');
    },
    async getMemberId() {
      await this.$store
        .dispatch('getUserMember', {
          id: this.currentUser.user_id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.modelItem.created_by = resp[0].member_id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modalOpenDelete() {
      this.modalOpenToDeleted = true;
    },
    closeModal() {
      this.modelItem = this.modelItemDefault;
      this.$emit('closeModal');
    },
    saveProjectCosts() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      if (this.modelItem.value === 'R$ 0,00') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Informar um valor maior que R$ 0,00',
            icon: 'XIcon',
            variant: 'danger',
          },
        });
        return;
      }

      if (
        this.modelItem.type === 'Parcelado' ||
        (this.modelItem.type === 'Recorrência' && this.installmentsInput > 0)
      ) {
        for (let i = 1; i <= parseInt(this.installmentsInput); i++) {
          const valueInstallments = this.monetaryOnlyCommas(
            this.$refs[`installments-value-${i}`][0].value,
          );

          const dateInstallments =
            this.$refs[`installments-date-${i}`][0].$refs.input.value;

          this.installments.push({
            value: valueInstallments,
            transaction_date: dateInstallments,
          });
        }
      }

      this.modelItem.workspace_id = this.currentWorkspace.id;
      this.$store
        .dispatch('saveProjectCosts', {
          ...this.modelItem,
          expense: true,
          project_id:
            this.modelItem.group === 'offices' ? '' : this.modelItem.project_id,
          value: parseInt(
            this.modelItem.value
              .replace('R$ ', '')
              .replace(',', '')
              .replace('.', '')
              .replace('.', ''),
          ),
          other_cost: true,
          installments: this.installments,
        })
        .then((resp) => {
          this.loading = false;
          if (resp) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Custo cadastrado com sucesso',
                icon: 'SuccessIcon',
                variant: 'success',
              },
            });
            this.modelItem = this.modelItemDefault;
            this.$emit('closeModal');
            this.$emit('updateList');
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao cadastrar custo',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },

    getProjectCosts() {
      this.loading = true;

      let cost_id = this.itemUpdate;

      this.$store
        .dispatch('getProjectCosts', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          id: cost_id,
        })
        .then((resp) => {
          this.loading = false;
          this.modelItem = {
            ...resp,
            reference_date: this.dateFormatter(
              resp.reference_date,
              'yyyy-MM-dd',
            ),
            value: this.numberToMonetary(resp.value),
            transaction_date: this.dateFormatter(
              resp.transaction_date,
              'yyyy-MM-dd',
            ),
          };
        })
        .catch(() => {
          this.loading = false;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao buscar custo',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },
    updateProjectCosts() {
      this.$refs.ModalProjectCosts.validate().then((success) => {
        if (success) {
          this.loading = true;
          this.$store
            .dispatch('updateProjectCosts', {
              ...this.modelItem,
              value: parseInt(
                this.modelItem.value
                  .replace('R$ ', '')
                  .replace('.', '')
                  .replace('.', '')
                  .replace(',', ''),
              ),
            })
            .then((resp) => {
              this.loading = false;
              if (resp) {
                this.$emit('renderList');
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Custo atualizado com sucesso',
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                });
                this.$emit('closeModal');
                this.modelItem = this.modelItemDefault;
              }
            })
            .catch(() => {
              this.loading = false;

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'erro ao atualizar o imposto',
                  icon: 'XIcon',
                  variant: 'danger',
                },
              });
            });
        }
      });
    },
    inactivateProjectCosts() {
      this.loading = true;
      this.$store
        .dispatch('inactivateProjectCosts', this.modelItem)
        .then((resp) => {
          this.loading = false;
          if (resp) {
            this.modalInactivate = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Custos inativada com sucesso',
                icon: 'SuccessIcon',
                variant: 'success',
              },
            });
            this.$router.push({ name: 'taxes' });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'erro ao inativa custo',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },
    activeCosts() {
      this.$refs.ModalProjectCosts.validate().then((success) => {
        if (success) {
          this.loading = true;
          this.$store
            .dispatch('activeCosts', this.itemUpdate)
            .then((resp) => {
              this.loading = false;
              if (resp) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Custo reativado com sucesso',
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                });
                this.$router.push({ name: 'taxes' });
              }
            })
            .catch(() => {
              this.loading = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'erro ao reativar custo',
                  icon: 'XIcon',
                  variant: 'danger',
                },
              });
            });
        }
      });
    },
    handleRepeatChange() {
      this.modelItem.isRepeatActive = this.modelItem.repeat === '0';
    },
    handleKeyPress() {
      // console.log({ repeat: this.modelItem, e });
      // this.repeatData
    },
    removeProjectCosts() {
      this.$refs.ModalProjectCosts.validate().then((success) => {
        if (success) {
          this.loading = true;
          this.$store
            .dispatch('removeProjectCosts', { id: this.itemUpdate })
            .then((resp) => {
              this.loading = false;
              if (resp) {
                this.$emit('renderList');
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Custo removido com sucesso',
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                });
                this.$emit('closeModal');
                this.modalInactivate = false;
                this.modelItem = this.modelItemDefault;
              }
            })
            .catch(() => {
              this.loading = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Erro ao deletar custo',
                  icon: 'XIcon',
                  variant: 'danger',
                },
              });
            });
          this.$emit('closeModal');
          this.modelItem = this.modelItemDefault;
        }
      });
    },
    async loadProjects() {
      let body = { workspace_id: this.$store.getters.currentWorkspace.id };
      try {
        await this.$store
          .dispatch('_getProjects', this.formatQueryParams(body))
          .then((resp) => {
            this.loading = false;
            this.projects = resp.data;
          });

        await this.$store
          .dispatch('getAllSuppliers', {
            workspace_id: this.$store.getters.currentWorkspace.id,
          })
          .then((resp) => {
            if (resp) {
              this.supplier = resp;
            }
          });

        await this.$store
          .dispatch('getAllCostsCategory', {
            inactive: false,
            workspace_id: this.$store.getters.currentWorkspace.id,
            other_cost: true,
          })
          .then((resp) => {
            if (resp) {
              this.categories = resp.data;
            }
          });
      } catch (error) {
        console.error('Erro ao carregar projetos', error);
      }
    },
  },
};
</script>
